import DRAWER from 'common/constants/drawer/Drawer.constants';
import { useGetNotes } from 'services/hooks/notes';
import { hasNoteContent } from 'services/hooks/notes/utilities';
import { NotesDrawerTabTitleProps } from './NotesDrawerTabTitle.props';

/**
 * Renders the Notes drawer tab title with count. Owns the notes query so the count
 * is available without selecting the tab; only runs when mounted (when notes tab exists).
 */
const isVisibleNote = (n: { 
  is_internal?: boolean;
  is_deleted?: boolean;
  temp_id?: string | null;
  content: string;
}) => !n.is_internal && !n.is_deleted && !n.temp_id && hasNoteContent(n.content);

const NotesDrawerTabTitle = ({ pageType, pageTypeKey, pageTypeId, notesFallback }: NotesDrawerTabTitleProps) => {
  const { data } = useGetNotes({ pageType, pageTypeKey, pageTypeId });
  const count = notesFallback !== null && notesFallback !== undefined
    ? notesFallback.filter(isVisibleNote).length
    : (data?.filter(isVisibleNote).length ?? 0);
  return <>{`${DRAWER.TABS.NOTES} (${count})`}</>;
};

export default NotesDrawerTabTitle;
